import { PostRequest } from "./http/BaseRequest";
import { BaseResponse } from "./http/responses/BaseResponse";
import { ServerResponse } from "./http/settings";
import W2UiFilterBuilder from "./w2ui";
import { SearchItem } from "./w2ui/w2const";

export type UserUrole = "a" | "u" | "m" | "t";
export interface UserI {
  id: string;
  email: string;
  name?: string;
  color: string;
  is_admin?: boolean;
  tags?: string; // JSON
  contractids?: string;
  contractnames?: string;
  Urole?: UserUrole;
  Uuid: string;

  m_online: number; // count miners online
  m_offline: number; // count miners offline
  m_low: number; // count miners low
  speed: number; // total speed all usr miners
}
// a - admin
// m - moder
// u - user
export interface UserAditional extends UserI {
  "2fa": boolean;

  link: string;
  PucComment?: string;
}

export interface IColoredUser extends UserI { }
export interface UsersResponseI extends ServerResponse {
  Records: UserAditional[];
  Total: number;
}

// как бы дублируется uri, но это для раздела Локации
// export class GetUsersRequests extends PostRequest {
//   constructor(offset = 0, limit = 20, search?: string) {
//     const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
//     if (search && typeof search === "string") {
//       builder.setSearch([
//         SearchItem.textContains("search", search.toLowerCase()),
//       ]);
//     }
//     const params = builder.build().stringParams;
//     super("/admin/user/list", params);
//   }
// }

// для раздела пользователи, с флагом all=true для получения всех пользователей
export class GetUsersRequestsAll extends PostRequest {
  constructor(offset = 0, limit = 20, search?: string) {
    const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
    if (search && typeof search === "string") {
      builder.setSearch([
        SearchItem.textContains("search", search.toLowerCase()),
      ]);
    }
    const params = builder.build().stringParams;
    super("/admin/user/list?all=true", params);
  }
}

export interface GetCurrentUserResponse extends BaseResponse {
  readonly Records: UserI[];
}

// export class GetUserById extends PostRequest {
//   constructor(userid: string) {
//     const builder = new W2UiFilterBuilder();
//     builder.setSearch([SearchItem.textIs("userid", userid)]);
//     const params = builder.build().stringParams;
//     super("/admin/user/list", params);
//   }
// }

// появилось из-за путанницы в параметрах, скорее всего в будущем что-то изменится
export class GetUsersRequestNoParams extends PostRequest {
  constructor() {
    super("/admin/user/list", {});
  }
}

export class CreateClientTags extends PostRequest {
  constructor(id: string, tags: string[]) {
    super("/admin/user/tags/update", {
      userid: id,
      tags: tags.join(","),
    });
  }
}

export class DeleteUser extends PostRequest {
  constructor(id: string) {
    super("admin/user/delete", { id });
  }
}

// export class DeleteClientTag extends PostRequest {
//   constructor(id: string, tag: string) {
//     super("/admin/user/tags/delete", { id, tag });
//   }
// }
